import { createBrowserRouter } from 'react-router-dom';
import { AuthGuard } from './AuthGuard';
import { AuthLayout } from '../layouts/AuthLayout';
import { AdminLayout } from '../layouts/AdminLayout';
import { LoginPage } from '../pages/auth/LoginPage';
import { TwoFactorPage } from '../pages/auth/TwoFactorPage';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import { UsersListPage } from '../pages/users/UsersListPage';
import { UserDetailPage } from '../pages/users/UserDetailPage';
import { OrgsListPage } from '../pages/organizations/OrgsListPage';
import { OrgDetailPage } from '../pages/organizations/OrgDetailPage';
import { SubscriptionsListPage } from '../pages/subscriptions/SubscriptionsListPage';
import { SubscriptionDetailPage } from '../pages/subscriptions/SubscriptionDetailPage';
import { InvoicesListPage } from '../pages/invoices/InvoicesListPage';
import { InvoiceDetailPage } from '../pages/invoices/InvoiceDetailPage';
import { TicketsListPage } from '../pages/support/TicketsListPage';
import { TicketDetailPage } from '../pages/support/TicketDetailPage';
import { EmailTemplatesListPage } from '../pages/support/EmailTemplatesListPage';
import { EmailTemplateEditPage } from '../pages/support/EmailTemplateEditPage';
import { AnalyticsPage } from '../pages/analytics/AnalyticsPage';
import { FeatureFlagsPage } from '../pages/system/FeatureFlagsPage';
import { AuditLogsPage } from '../pages/system/AuditLogsPage';
import { SystemHealthPage } from '../pages/system/SystemHealthPage';
import { AdminUsersListPage } from '../pages/system/AdminUsersListPage';
import { AdminUserDetailPage } from '../pages/system/AdminUserDetailPage';
import { SecuritySettingsPage } from '../pages/settings/SecuritySettingsPage';
import { NotFoundPage } from '../pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <AuthLayout />,
    children: [
      { index: true, element: <LoginPage /> },
      { path: '2fa', element: <TwoFactorPage /> },
    ],
  },
  {
    path: '/',
    element: <AuthGuard><AdminLayout /></AuthGuard>,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'users', element: <UsersListPage /> },
      { path: 'users/:id', element: <UserDetailPage /> },
      { path: 'organizations', element: <OrgsListPage /> },
      { path: 'organizations/:id', element: <OrgDetailPage /> },
      { path: 'subscriptions', element: <SubscriptionsListPage /> },
      { path: 'subscriptions/:id', element: <SubscriptionDetailPage /> },
      { path: 'invoices', element: <InvoicesListPage /> },
      { path: 'invoices/:id', element: <InvoiceDetailPage /> },
      { path: 'support/tickets', element: <TicketsListPage /> },
      { path: 'support/tickets/:id', element: <TicketDetailPage /> },
      { path: 'support/email-templates', element: <EmailTemplatesListPage /> },
      { path: 'support/email-templates/new', element: <EmailTemplateEditPage /> },
      { path: 'support/email-templates/:id', element: <EmailTemplateEditPage /> },
      { path: 'analytics', element: <AnalyticsPage /> },
      { path: 'system/feature-flags', element: <FeatureFlagsPage /> },
      { path: 'system/audit-logs', element: <AuditLogsPage /> },
      { path: 'system/health', element: <SystemHealthPage /> },
      { path: 'system/admin-users', element: <AdminUsersListPage /> },
      { path: 'system/admin-users/:id', element: <AdminUserDetailPage /> },
      { path: 'settings/security', element: <SecuritySettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
